<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="button-area" style="margin: 0"   v-loading.fullscreen.lock="fullscreenLoading">
      <el-button size="medium" type="info" @click="bitchExport">导出</el-button>
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%"  :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="accountMonth"
          label="核算月份"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="150"
        >
          <template slot-scope="scope">{{ scope.row.accountMonth | getMonth }}</template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="姓名"
          header-align="center"
          align="center"
          show-overflow-tooltip
          width="150"
        ></el-table-column>
        <el-table-column
          prop="mobileNo"
          label="手机号"
          header-align="center"
          align="center"
          show-overflow-tooltip
          width="150"
        ></el-table-column>
        <el-table-column
          prop="organisationName"
          label="部门"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="150"
        ></el-table-column>
        <el-table-column
          prop="taskChineseName"
          label="任务内容"
          header-align="center"
          align="center"
          show-overflow-tooltip
          width="150"
        >
            <template slot-scope="scope">{{ scope.row.taskChineseName||'-' }}</template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="createTime"
          label="时间"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          width="200"
          prop="customerName"
          label="客户名称"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">{{ scope.row.customerName||'-' }}</template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          width="400"
          prop="checkedIssues"
          label="整改内容"
          header-align="center"
          align="left"
        >
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>


  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: this.$route.query.tenantGuid,
        accountMonth: this.$route.query.accountMonth,
        staffGuid: this.$route.query.staffGuid,
      },
      evaluationContent: '',
      orderNum: '',
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,

      dialogTxt: '设置考核机制',
      dialogCheckVisible: false,
      evaluationTable: [],
      taskEvaluationGuid: '',
      evaluationTypeList: [
        { label: '数量要求', value: '1' },
        { label: '质量要求', value: '2' },
      ],
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
        //批量导出
    bitchExport() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: this.$route.query.tenantGuid,
        accountMonth: this.$route.query.accountMonth,
        staffGuid: this.$route.query.staffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-audit/task/audit-detail-export`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    getList() {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/task-audit/task/audit-detail`, this.page)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
   
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>